import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';
import $ from 'jquery';

export default function theTree() {
  if (document.querySelector('.the-tree__point-content')) {
    tippy('.the-tree__point-content', {
      interactive: true,
      // trigger: 'click',
      animation: 'scale',
      content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      flip: false,
      flipBehavior: ['bottom', 'left'],

      // onHide(instance) {
      //   $('.click-event').on("click", function(){
      //
      //
      //   });
      // },
    });


    $('.the-tree .container').mousemove(function(event){
      let relX = event.pageX - $(this).offset().left;
      let relY = event.pageY - $(this).offset().top;

      $('.circle').removeClass('is-transform');

      // row 2
      if (relY >= 170 && relY <= 350) {
        if (relX >= 180 && relX <= 345 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(2)').addClass('is-transform');
          $('.circle:nth-child(3)').addClass('is-transform');
          $('.circle:nth-child(16)').addClass('is-transform');
        } else if (relX >= 350 && relX <= 500 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(3)').addClass('is-transform');
          $('.circle:nth-child(4)').addClass('is-transform');
          $('.circle:nth-child(17)').addClass('is-transform');
        } else if (relX >= 500 && relX <= 655 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(4)').addClass('is-transform');
          $('.circle:nth-child(5)').addClass('is-transform');
          $('.circle:nth-child(15)').addClass('is-transform');
          $('.circle:nth-child(16)').addClass('is-transform');
          $('.circle:nth-child(17)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 815 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(5)').addClass('is-transform');
          $('.circle:nth-child(6)').addClass('is-transform');
          $('.circle:nth-child(7)').addClass('is-transform');
          $('.circle:nth-child(8)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 970 ) {
          $('.circle:nth-child(6)').addClass('is-transform');
          $('.circle:nth-child(7)').addClass('is-transform');
          $('.circle:nth-child(8)').addClass('is-transform');
        }
      }

      // row 3
      if (relY >= 350 && relY <= 530) {
        if (relX >= 180 && relX <= 345 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(13)').addClass('is-transform');
          $('.circle:nth-child(14)').addClass('is-transform');
          $('.circle:nth-child(16)').addClass('is-transform');
        } else if (relX >= 350 && relX <= 500 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
          $('.circle:nth-child(13)').addClass('is-transform');
          $('.circle:nth-child(14)').addClass('is-transform');
          $('.circle:nth-child(16)').addClass('is-transform');
          $('.circle:nth-child(17)').addClass('is-transform');
        } else if (relX >= 500 && relX <= 655 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(8)').addClass('is-transform');
          $('.circle:nth-child(10)').addClass('is-transform');
          $('.circle:nth-child(16)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 815 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(7)').addClass('is-transform');
          $('.circle:nth-child(8)').addClass('is-transform');
          $('.circle:nth-child(9)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 970 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(7)').addClass('is-transform');
          $('.circle:nth-child(8)').addClass('is-transform');
        }
      }

      // row 4
      if (relY >= 530 && relY <= 700) {
        if (relX >= 180 && relX <= 345 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(12)').addClass('is-transform');
          $('.circle:nth-child(13)').addClass('is-transform');
        } else if (relX >= 350 && relX <= 500 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
          $('.circle:nth-child(12)').addClass('is-transform');
          $('.circle:nth-child(13)').addClass('is-transform');
        } else if (relX >= 500 && relX <= 655 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 815 ) {
          $('.circle:nth-child(1)').addClass('is-transform');
          $('.circle:nth-child(9)').addClass('is-transform');
          $('.circle:nth-child(10)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
          $('.circle:nth-child(12)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 970 ) {
          $('.circle:nth-child(9)').addClass('is-transform');
        }
      }

      // row 5
      if (relY >= 700 && relY <= 875) {
        if (relX >= 180 && relX <= 345 ) {
          // $('.circle:nth-child(13)').addClass('is-transform');
          // $('.circle:nth-child(14)').addClass('is-transform');
        } else if (relX >= 350 && relX <= 500 ) {
          $('.circle:nth-child(11)').addClass('is-transform');
          $('.circle:nth-child(12)').addClass('is-transform');
        } else if (relX >= 500 && relX <= 655 ) {
          $('.circle:nth-child(11)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 815 ) {
          $('.circle:nth-child(10)').addClass('is-transform');
          $('.circle:nth-child(11)').addClass('is-transform');
        } else if (relX >= 655 && relX <= 970 ) {
          // l
        }
      }
    });
  }
}
